import { Accordion, AccordionButton, AccordionItem, AccordionIcon, AccordionPanel, } from "@chakra-ui/react";
import AccordionTitle from "./AccordionTitle";
import AccordionTheme from "./theme";
export { Accordion, AccordionButton, AccordionItem, AccordionIcon, AccordionPanel, AccordionTitle, AccordionTheme, };
//# sourceMappingURL=index.js.map